var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapperContainer"}},[_c('Menu'),_c('main',[(_vm.showModal)?_c('Modal',{attrs:{"onClose":_vm.onCloseModal}}):_vm._e(),_c('router-view'),(_vm.playerActive)?_c('PlayerBar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }